import * as theme from "../theme";

import styled from "styled-components";

const HeaderText = ({ bigger_text, smaller_text, medium_text }) => {
  return (
    <Wrapper>
      <BiggerTextContainer>
        <BiggerText>{bigger_text}</BiggerText>
      </BiggerTextContainer>
      {medium_text && (
        <BiggerTextContainer>
          <BiggerText>{medium_text}</BiggerText>
        </BiggerTextContainer>
      )}
      {smaller_text && (
        <SmallerTextContainer>
          <SmallerText>{smaller_text}</SmallerText>
        </SmallerTextContainer>
      )}
      <BlueLine />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)`
  width: 100%;
`;

const BiggerTextContainer = styled.div`
  @media (max-width: ${theme.mobile}) {
    width: 95vw;
    margin: 0px auto;
  }
`;

const BiggerText = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 64px;
  margin-bottom: 16px;
  margin-top: 0px;
  text-align: center;

  @media (max-width: ${theme.tablet}) {
    font-size: 32px;
    line-height: 32px;
  }

  @media (max-width: ${theme.mobile}) {
    font-size: 28px;
    line-height: 28px;
  }
`;

const SmallerTextContainer = styled.div`
  @media (max-width: ${theme.tablet}) {
    width: 80%;
    margin: 0px auto;
  }
  /* @media (max-width: ${theme.mobile}) {
    width: 80%;
    margin: 0px auto;
  } */
`;

const SmallerText = styled.h3`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  margin: 16px 0px;
  text-align: center;
  @media (max-width: ${theme.tablet}) {
    font-size: 16px;
    line-height: 16px;
    margin: 8px 0px 16px 0px;
  }

  @media (max-width: ${theme.mobile}) {
    font-size: 14px;
    line-height: 14px;
  }
`;

const BlueLine = styled.div`
  width: 86px;
  height: 4px;
  background: ${theme.primary_light};
  @media (max-width: ${theme.tablet}) {
    height: 2px;
  }
`;

export default HeaderText;
